export {
	requestAsyncStop,
	type StopRequest,
} from "../runs/background/control-channel.ts";
